import PropTypes from 'prop-types';

const InputRefType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
]);

export default InputRefType;
